import { useLocation } from 'react-router-dom'

export default useQuery = ->
  new URLSearchParams(useLocation().search)
